module.exports = __webpack_public_path__ + "static/media/empty-message.4e7989ab.svg";